import {useNavigate} from 'react-router-dom'
import eatImage from '../images/eat-event.png';
import iceEx from '../images/iceEx.png'
import postEx from '../images/postEx.png'
import { Button, Container ,Row ,Col} from "react-bootstrap";
import './css/Common.css'
import './css/StartPage.css'

export default function StartPageCompenent(){
    const navigate = useNavigate()

    const handleLogin = () => {
      navigate(`/login`)
    };

    const handleRegister = () => {
      navigate(`/register`)
    };

    return(
      <Container className='py-4'>
  
        <Row className="px-5 pt-3 justify-content-center text-center">
          <Col md={10}>
            <h1 className="display-4 start_purple start_section_text">
              讓旅人和在地人，用一頓飯相遇。
            </h1>
            <p className="lead mt-3 mb-4 start_purple start_section_subtext">
              認識在地人，一起吃飯。用一頓飯打開一座城市。
            </p>
          </Col>
        </Row>

        <Row className='start_hero_section'>
          <div className='start_button_group'>
            <Button
              className="px-4 start_button1"
              onClick={handleLogin}
            >
              LOG IN
            </Button>
            <Button
              className="px-4 start_button2"
              onClick={handleRegister}
            >
              SIGN UP
            </Button>
          </div>
        </Row>

        <Row className="align-items-center m-3">
          <Col md={8} className="text-center mb-3">
            <img src={postEx} alt="收費機制" className="img-fluid feature_image"/>
          </Col>

          <Col md={4}>
            <h3 className="fw-bold start_purple fs-1 pb-3">收費機制</h3>
            <p className='start_purple fs-4'>雙方吃飯免費，可加購祕笈。</p>
            <p className='start_purple fs-4'>🔒  解鎖在地人的私藏景點與口袋美食清單 !!!不踩雷、不觀光，真正在地。</p>
            <p className='start_purple fs-4'>一起品嚐隱藏的故事與好味道</p>
          </Col>
        </Row>

        <Row className="align-items-center m-3">
          <Col md={4}>
            <h3 className="fw-bold fs-1 pb-4">Icebreaker<br />問題產生器</h3>
            <div className='fs-4'>
              <p>Ask區塊可隨機產生破冰問題。<br />Answer區塊可錄製回答，<br />並語音播放翻譯結果！</p>
            </div>
          </Col>
          <Col md={8} className="text-center">
            <img src={iceEx} alt="Icebreaker" className="img-fluid feature_image"/>
          </Col>
        </Row>
    </Container>

    )
}